// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"464":"bec6c3bd","917":"20afcbbf"}[chunkId] + ".chunk.js";
};